import { createSlice } from "@reduxjs/toolkit";
import reducers from "./reducers";
import { UserState } from "types/User";

const initialState: UserState = {
  loading: false,
  users: [],
  filterRoleMembers: [],
  nonFilterRoleMembers: [],
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers,
});

export const { setUsers, setFilterRoleMembers, setNonFilterRoleMembers } = userSlice.actions;

export default userSlice.reducer;
